var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H12.25",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0837 3.5V11.6667C11.0837 12.25 10.5003 12.8333 9.91699 12.8333H4.08366C3.50033 12.8333 2.91699 12.25 2.91699 11.6667V3.5",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 3.49984V2.33317C4.66699 1.74984 5.25033 1.1665 5.83366 1.1665H8.16699C8.75033 1.1665 9.33366 1.74984 9.33366 2.33317V3.49984",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 6.4165V9.9165",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 6.4165V9.9165",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ff3b8c4d642856954cddf0e51719ed04.svg";
export { ForwardRef as ReactComponent };